import { InputNumber, InputNumberProps } from 'primereact/inputnumber';

import './style.css';

interface ICustomInputNumber extends InputNumberProps {
    label?: string;
    labelStyle?: React.CSSProperties;
    error?: string | null;
}

const CustomInputNumber: React.FC<ICustomInputNumber> = ({
    label,
    name,
    labelStyle,
    error,
    ...rest
}) => {
    return (
        <div className='custom-input-number'>
            <span>
                <label
                    htmlFor={name}
                    style={{
                        marginRight: '8px',
                        display : label ? 'inherit' : 'none',
                        ...labelStyle,
                    }}
                >
                    {label}
                </label>
                <InputNumber {...rest} />
                {error && (
                    <small
                        id={`${name}-help`}
                        className='p-error block input-text-error'
                    >
                        {error}
                    </small>
                )}
            </span>
        </div>
    );
};

export default CustomInputNumber;
